module.exports = __webpack_public_path__ + "static/media/reload2.26fa7821.svg";